// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"297e2b03","453":"14e6ad19","455":"8917e541"}[chunkId] + ".chunk.js";
};